import { useEffect, useState } from "react"

const POSTHOG_LOADED_EVENT = "posthog:loaded"

const usePosthogLoaded = () => {
    const [posthogLoaded, setPosthogLoaded] = useState(false)

    useEffect(() => {
        const handlePosthog = () => {
            setPosthogLoaded(true)
        }

        if (window.posthog?.__loaded) setPosthogLoaded(true)
        window.addEventListener(POSTHOG_LOADED_EVENT, handlePosthog)
        return () => {
            window.removeEventListener(POSTHOG_LOADED_EVENT, handlePosthog)
        }
    }, [])

    return posthogLoaded
}

export { usePosthogLoaded, POSTHOG_LOADED_EVENT }
